/* KitKraft — "Wire the Build". A workbench: real components around an Arduino
   Nano. Tap a component's lead, tap a header pin — a jumper wire snaps in. The
   pin has to be able to do the job (analog / PWM / I²C / output), not be a
   reserved serial pin, not be taken. Wire it right and the build RUNS: LEDs
   blink, motors spin, the screen scrolls. 4 builds. Tap-driven; the run state
   is CSS animation (no rAF). */
(function () {
  "use strict";

  var NS = "http://www.w3.org/2000/svg";
  var WIRE_COLORS = ["#f5a524", "#3ecf8e", "#4a8cff", "#e5484d", "#c07bff", "#e7edf6", "#ff8fab"];

  function T(name, x, y) {
    return '<g class="term" data-term="' + name + '" transform="translate(' + x + ',' + y + ')">'
      + '<circle r="12" fill="transparent"/><circle class="tsel" r="8"/><circle class="tdot" r="4.5"/></g>';
  }

  var ART = {
    led:
      '<circle class="fx led-glow" cx="0" cy="-3" r="18" fill="#ffe27a"/>'
      + '<ellipse class="led-dome" cx="0" cy="-3" rx="11" ry="13" fill="#ff5a5f" stroke="#7f2b2e" stroke-width="2"/>'
      + '<rect x="-11" y="-3" width="22" height="5" rx="1" fill="#c9464a"/>'
      + '<path class="lead" d="M-5 2 V22"/><path class="lead" d="M5 2 V15"/>'
      + T("sig", -5, 22),
    button:
      '<rect x="-12" y="-12" width="24" height="24" rx="3" fill="#20304a" stroke="#4a8cff" stroke-width="2"/>'
      + '<circle cx="0" cy="0" r="8" fill="#3f6fd8"/>'
      + '<circle class="fx btn-press" cx="0" cy="0" r="8" fill="#cfe3ff"/>'
      + '<path class="lead" d="M-8 12 V22"/><path class="lead" d="M8 12 V18" opacity="0.4"/>'
      + T("sig", -8, 22),
    buzzer:
      '<circle class="fx buz-wave" cx="0" cy="-1" r="15" fill="none" stroke="#ffd24a" stroke-width="2"/>'
      + '<circle class="fx buz-wave" cx="0" cy="-1" r="15" fill="none" stroke="#ffd24a" stroke-width="2"/>'
      + '<circle class="fx buz-wave" cx="0" cy="-1" r="15" fill="none" stroke="#ffd24a" stroke-width="2"/>'
      + '<circle cx="0" cy="-1" r="13" fill="#141414" stroke="#000" stroke-width="2"/>'
      + '<circle cx="0" cy="-1" r="2.5" fill="#3a3a3a"/>'
      + '<path class="lead" d="M-5 11 V24"/>'
      + T("sig", -5, 24),
    motor:
      '<rect x="-17" y="-11" width="28" height="22" rx="7" fill="#c4c4c4" stroke="#666" stroke-width="2"/>'
      + '<rect x="-17" y="-11" width="9" height="22" rx="7" fill="#a6a6a6"/>'
      + '<rect x="11" y="-2.5" width="6" height="5" fill="#888"/>'
      + '<g class="mot-blades" transform="translate(20,0)">'
      + '<ellipse cx="0" cy="-8" rx="3.5" ry="9" fill="#4a8cff" stroke="#123a99" stroke-width="1.4"/>'
      + '<ellipse cx="0" cy="8" rx="3.5" ry="9" fill="#4a8cff" stroke="#123a99" stroke-width="1.4"/>'
      + '<ellipse cx="-8" cy="0" rx="9" ry="3.5" fill="#4a8cff" stroke="#123a99" stroke-width="1.4"/>'
      + '<ellipse cx="8" cy="0" rx="9" ry="3.5" fill="#4a8cff" stroke="#123a99" stroke-width="1.4"/>'
      + '<circle r="2.5" fill="#123a99"/></g>'
      + '<path class="lead" d="M-17 -5 H-30 V26"/><path class="lead" d="M-17 5 H-40 V26"/>'
      + T("speed", -30, 26) + T("dir", -40, 26),
    ldr:
      '<line class="fx ldr-ray" x1="0" y1="-15" x2="0" y2="-23" stroke="#ffd24a" stroke-width="2.5"/>'
      + '<line class="fx ldr-ray" x1="-8" y1="-13" x2="-12" y2="-20" stroke="#ffd24a" stroke-width="2.5"/>'
      + '<line class="fx ldr-ray" x1="8" y1="-13" x2="12" y2="-20" stroke="#ffd24a" stroke-width="2.5"/>'
      + '<line class="fx ldr-ray" x1="-13" y1="-7" x2="-21" y2="-11" stroke="#ffd24a" stroke-width="2.5"/>'
      + '<line class="fx ldr-ray" x1="13" y1="-7" x2="21" y2="-11" stroke="#ffd24a" stroke-width="2.5"/>'
      + '<circle cx="0" cy="0" r="12" fill="#e9e9e9" stroke="#7a7a7a" stroke-width="2"/>'
      + '<path d="M-7 5 q3.5 -11 7 0 q3.5 11 7 0" fill="none" stroke="#8a7a5a" stroke-width="2"/>'
      + '<path class="lead" d="M-4 12 V24"/>'
      + T("sig", -4, 24),
    ir:
      '<rect x="-17" y="-9" width="34" height="18" rx="2" fill="#12558a" stroke="#0c3f66" stroke-width="2"/>'
      + '<circle cx="-8" cy="0" r="4.5" fill="#141414"/><circle cx="8" cy="0" r="4.5" fill="#4a1f1f"/>'
      + '<path class="fx ir-beam" d="M-8 6 L-12 22 L-4 22 Z" fill="#ff6b6b"/>'
      + '<path class="fx ir-beam" d="M8 6 L4 22 L12 22 Z" fill="#ffb0b0"/>'
      + '<path class="lead" d="M0 9 V24"/>'
      + T("sig", 0, 24),
    oled:
      '<rect x="-22" y="-15" width="44" height="30" rx="2" fill="#0a0f18" stroke="#3a5a8a" stroke-width="2"/>'
      + '<rect x="-18" y="-11" width="36" height="21" fill="#04263f"/>'
      + '<rect class="fx oled-on" x="-18" y="-11" width="36" height="21" fill="#0c3e63"/>'
      + '<polyline class="fx oled-trace" points="-16,2 -10,-6 -4,5 2,-6 8,5 14,-4 18,1" fill="none" stroke="#5fe0ff" stroke-width="2"/>'
      + '<path class="lead" d="M-8 15 V26"/><path class="lead" d="M8 15 V26"/>'
      + T("sda", -8, 26) + T("scl", 8, 26),
    chip:
      '<rect x="-14" y="-10" width="28" height="20" rx="2" fill="#1a1a1a" stroke="#000" stroke-width="1.5"/>'
      + '<text x="0" y="2.5" text-anchor="middle" fill="#7a9a7a" font-family="monospace" font-size="5.5" font-weight="700">BME280</text>'
      + '<circle class="fx chip-dot" cx="10" cy="-6" r="2" fill="#3ecf8e"/>'
      + '<path class="lead" d="M-9 10 V22"/><path class="lead" d="M9 10 V22"/>'
      + T("sda", -9, 22) + T("scl", 9, 22)
  };

  var TERM = {
    led: { sig: [-5, 22] }, button: { sig: [-8, 22] }, buzzer: { sig: [-5, 24] },
    motor: { speed: [-30, 26], dir: [-40, 26] }, ldr: { sig: [-4, 24] }, ir: { sig: [0, 24] },
    oled: { sda: [-8, 26], scl: [8, 26] }, chip: { sda: [-9, 22], scl: [9, 22] }
  };

  var PWM = { D3: 1, D5: 1, D6: 1, D9: 1, D10: 1, D11: 1 };
  var DIG = ["D0", "D1", "D2", "D3", "D4", "D5", "D6", "D7", "D8", "D9", "D10", "D11", "D12", "D13"];
  var ANA = ["A0", "A1", "A2", "A3", "A4", "A5", "A6", "A7"];
  var BUS = { "i2c-sda": 1, "i2c-scl": 1 };

  function pinDef(id) {
    if (id === "D0") return { id: id, t: ["digital", "out"], reserved: "RX" };
    if (id === "D1") return { id: id, t: ["digital", "out"], reserved: "TX" };
    if (id.charAt(0) === "D") { var t = ["digital", "out"]; if (PWM[id]) t.push("pwm"); return { id: id, t: t }; }
    if (id === "A4") return { id: id, t: ["digital", "out", "analog", "i2c-sda"] };
    if (id === "A5") return { id: id, t: ["digital", "out", "analog", "i2c-scl"] };
    if (id === "A6" || id === "A7") return { id: id, t: ["analog"] };
    return { id: id, t: ["digital", "out", "analog"] };
  }
  function has(pin, tok) { return pin.t.indexOf(tok) >= 0; }

  var CT = {
    "pwm": ["~ PWM", "t-pwm"], "analog": ["ANALOG", "t-analog"],
    "i2c-sda": ["I²C SDA", "t-i2c"], "i2c-scl": ["I²C SCL", "t-i2c"],
    "digital": ["DIGITAL", "t-digital"], "out": ["OUTPUT", "t-out"]
  };

  var ROUNDS = [
    {
      name: "Blink & beep",
      brief: "An LED, a button and a buzzer — the first thing anyone wires up.",
      parts: [
        { id: "led", kind: "led", x: 95, y: 78, label: "LED" },
        { id: "btn", kind: "button", x: 220, y: 78, label: "Button" },
        { id: "buz", kind: "buzzer", x: 345, y: 78, label: "Buzzer" }
      ],
      conns: [
        { part: "led", term: "sig", label: "LED", need: ["out"] },
        { part: "btn", term: "sig", label: "Button", need: ["digital"] },
        { part: "buz", term: "sig", label: "Buzzer", need: ["out"] }
      ]
    },
    {
      name: "Night light",
      brief: "Fade an LED up as the room darkens; a button forces it full-on.",
      parts: [
        { id: "ldr", kind: "ldr", x: 95, y: 80, label: "Light sensor" },
        { id: "led", kind: "led", x: 220, y: 78, label: "LED · fades" },
        { id: "btn", kind: "button", x: 345, y: 78, label: "Override" }
      ],
      conns: [
        { part: "ldr", term: "sig", label: "Light sensor", need: ["analog"] },
        { part: "led", term: "sig", label: "LED fade", need: ["pwm"] },
        { part: "btn", term: "sig", label: "Override btn", need: ["digital"] }
      ]
    },
    {
      name: "Line follower",
      brief: "Two IR eyes on the line, two motors, a mode button. Mind the PWM pins.",
      parts: [
        { id: "irL", kind: "ir", x: 46, y: 70, label: "IR left" },
        { id: "irR", kind: "ir", x: 134, y: 70, label: "IR right" },
        { id: "mA", kind: "motor", x: 236, y: 70, label: "Motor A" },
        { id: "mB", kind: "motor", x: 332, y: 70, label: "Motor B" },
        { id: "btn", kind: "button", x: 406, y: 72, label: "Mode" }
      ],
      conns: [
        { part: "irL", term: "sig", label: "IR left", need: ["digital"] },
        { part: "irR", term: "sig", label: "IR right", need: ["digital"] },
        { part: "mA", term: "speed", label: "Motor A speed", need: ["pwm"] },
        { part: "mB", term: "speed", label: "Motor B speed", need: ["pwm"] },
        { part: "mA", term: "dir", label: "Motor A dir", need: ["digital"] },
        { part: "mB", term: "dir", label: "Motor B dir", need: ["digital"] },
        { part: "btn", term: "sig", label: "Mode button", need: ["digital"] }
      ]
    },
    {
      name: "Weather display",
      brief: "A BME280 and an OLED share one I²C bus. Plus a light sensor and a status LED.",
      parts: [
        { id: "bme", kind: "chip", x: 78, y: 74, label: "BME280" },
        { id: "oled", kind: "oled", x: 198, y: 74, label: "OLED" },
        { id: "ldr", kind: "ldr", x: 308, y: 76, label: "Light" },
        { id: "led", kind: "led", x: 398, y: 74, label: "Status LED" }
      ],
      conns: [
        { part: "bme", term: "sda", label: "BME280 SDA", need: ["i2c-sda"] },
        { part: "bme", term: "scl", label: "BME280 SCL", need: ["i2c-scl"] },
        { part: "oled", term: "sda", label: "OLED SDA", need: ["i2c-sda"] },
        { part: "oled", term: "scl", label: "OLED SCL", need: ["i2c-scl"] },
        { part: "ldr", term: "sig", label: "Light sensor", need: ["analog"] },
        { part: "led", term: "sig", label: "Status LED", need: ["out"] }
      ]
    }
  ];

  function reason(conn, pin, ownerLabel) {
    if (pin.reserved) return "D0 / D1 are the serial pins — leave them free for uploads.";
    if (ownerLabel) return "Pin " + pin.id + " is already wired to " + ownerLabel + ".";
    var n = conn.need[0];
    if (n === "pwm") return "Pin " + pin.id + " has no PWM. Fades and motor speed need a ~ pin: D3, D5, D6, D9, D10, D11.";
    if (n === "analog") return "Pin " + pin.id + " is digital-only. An analog sensor reads on A0–A7.";
    if (n === "i2c-sda") return "SDA is A4 on the Nano — every I²C device shares that one pin.";
    if (n === "i2c-scl") return "SCL is A5 on the Nano — shared by every I²C device.";
    if (n === "out" || n === "digital") {
      if (has(pin, "analog") && !has(pin, "out")) return "A6 / A7 are analog-input only — no output driver. Use A0–A5 or a D pin.";
      return "Pin " + pin.id + " won't work for this one.";
    }
    return "Not that pin.";
  }

  function wirePath(a, b) {
    var k = Math.min(70, Math.max(28, Math.abs(b.y - a.y) * 0.5));
    return "M " + a.x + " " + a.y + " C " + a.x + " " + (a.y + k) + ", " + b.x + " " + (b.y - k) + ", " + b.x + " " + b.y;
  }

  function board() {
    var s = '<rect class="brd" x="44" y="182" width="352" height="74" rx="6"/>'
      + '<rect class="brd-usb" x="20" y="200" width="26" height="26" rx="2"/>'
      + '<rect class="brd-mcu" x="196" y="200" width="40" height="34" rx="2"/>'
      + '<text class="brd-txt" x="300" y="222" font-size="11">ARDUINO NANO</text>'
      + '<circle class="brd-led" cx="64" cy="198" r="3"/>';
    return s;
  }

  function initOne(root) {
    if (root.dataset.kkwireInit) return;
    root.dataset.kkwireInit = "1";

    var el = {
      rounds: root.querySelector("[data-kkwire-rounds]"),
      name: root.querySelector("[data-kkwire-name]"),
      brief: root.querySelector("[data-kkwire-brief]"),
      scene: root.querySelector("[data-kkwire-scene]"),
      list: root.querySelector("[data-kkwire-list]"),
      msg: root.querySelector("[data-kkwire-msg]"),
      go: root.querySelector("[data-kkwire-go]"),
      next: root.querySelector("[data-kkwire-next]"),
      start: root.querySelector("[data-kkwire-start]"),
      again: root.querySelector("[data-kkwire-again]"),
      cta: root.querySelector("[data-kkwire-cta]"),
      wonH: root.querySelector("[data-kkwire-won-h]"),
      wonP: root.querySelector("[data-kkwire-won-p]")
    };

    // Defensive guard - see kk-sort.js for why (a real "Cannot read properties
    // of null" was seen on the Kit Shelf page, exact game not pinned down).
    for (var elKey in el) { if (!el[elKey]) return; }

    el.cta.textContent = root.getAttribute("data-cta-label") || "See the kits";
    el.cta.setAttribute("href", root.getAttribute("data-cta-href") || "#");

    var idx = 0, clean = 0, conns = [], pinmap = {}, sel = -1, misses = 0, wires = null;

    function pinPos(id) { var p = pinmap[id]; return { x: p.x, y: p.y }; }
    function termPos(c) {
      var pt = ROUNDS[idx].parts.filter(function (p) { return p.id === c.part; })[0];
      var lo = TERM[pt.kind][c.term];
      return { x: pt.x + lo[0], y: pt.y + lo[1] };
    }

    function render() {
      var r = ROUNDS[idx];
      root.classList.remove("uploaded", "running", "sel-on");
      el.rounds.innerHTML = "build <b>" + (idx + 1) + "</b>/4";
      el.name.textContent = r.name;
      el.brief.textContent = r.brief;
      sel = -1; misses = 0; pinmap = {};

      var svg = board();
      // header pins
      var i, x;
      for (i = 0; i < DIG.length; i++) {
        var d = pinDef(DIG[i]); x = 52 + i * (336 / 13);
        pinmap[d.id] = { id: d.id, x: x, y: 176, t: d.t, reserved: d.reserved };
        svg += pinG(d, x, 176, -10);
      }
      for (i = 0; i < ANA.length; i++) {
        var a = pinDef(ANA[i]); x = 92 + i * (256 / 7);
        pinmap[a.id] = { id: a.id, x: x, y: 262, t: a.t, reserved: a.reserved };
        svg += pinG(a, x, 262, 16);
      }
      // wires layer
      svg += '<g class="kkwire__wires" data-wires></g>';
      // parts
      r.parts.forEach(function (p) {
        svg += '<g class="part kkw-' + p.kind + '" data-part="' + p.id + '" transform="translate(' + p.x + ',' + p.y + ')">'
          + ART[p.kind]
          + '<text class="plabel" y="42">' + p.label + '</text></g>';
      });
      el.scene.innerHTML = svg;
      wires = el.scene.querySelector("[data-wires]");

      conns = r.conns.map(function (c, k) {
        return { i: k, part: c.part, term: c.term, label: c.label, need: c.need, pin: null, color: WIRE_COLORS[k % WIRE_COLORS.length], _wire: null };
      });

      el.list.innerHTML = "";
      conns.forEach(function (c) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "kkwire__conn"; b.setAttribute("data-i", c.i);
        var ct = CT[c.need[0]] || ["PIN", "t-digital"];
        b.innerHTML = '<span class="dotc" style="color:' + c.color + '"></span>'
          + '<span>' + c.label + '</span>'
          + '<span class="ct ' + ct[1] + '">' + ct[0] + '</span>'
          + '<span class="cs"></span>';
        b.addEventListener("click", function () { selectConn(c.i); });
        el.list.appendChild(b);
      });

      el.go.disabled = true;
      msg("Tap a component lead, then a pin that can drive it.");
      refresh();
    }

    function pinG(d, x, y, lblDy) {
      var kind = (d.id === "A4" || d.id === "A5") ? " k-i2c" : PWM[d.id] ? " k-pwm"
        : (d.id.charAt(0) === "A") ? " k-analog" : "";
      var lbl = PWM[d.id] ? "~" + d.id : d.id;
      return '<g class="pin' + kind + (d.reserved ? " reserved" : "") + '" data-pin="' + d.id + '" transform="translate(' + x + ',' + y + ')">'
        + '<circle r="11" fill="transparent"/><circle class="ring" cx="0" cy="0" r="6"/>'
        + '<circle class="hole" r="4.5"/>'
        + '<text class="plbl" y="' + lblDy + '" text-anchor="middle" font-size="7">' + lbl + '</text></g>';
    }

    function msg(t, k) { el.msg.textContent = t; el.msg.className = "kkwire__msg" + (k ? " " + k : ""); }

    function termEl(c) {
      return el.scene.querySelector('.part[data-part="' + c.part + '"] .term[data-term="' + c.term + '"]');
    }

    function selectConn(i) {
      if (root.classList.contains("running")) return;
      var c = conns[i];
      if (c.pin) { // unwire
        var pid = c.pin; c.pin = null;
        if (c._wire) { c._wire.parentNode.removeChild(c._wire); c._wire = null; }
        paintPin(pid);
        sel = i; markSel();
        msg("Unwired " + c.label + ". Pick a pin for it.");
        el.go.disabled = true; refresh();
        return;
      }
      sel = (sel === i ? -1 : i);
      markSel();
      if (sel >= 0) msg("Now tap a pin for " + c.label + " (" + (CT[c.need[0]] || ["", ""])[0] + ").");
    }

    function markSel() {
      [].forEach.call(el.list.children, function (b, k) { b.classList.toggle("sel", k === sel); });
      [].forEach.call(el.scene.querySelectorAll(".term"), function (t) { t.classList.remove("sel"); });
      if (sel >= 0) { var t = termEl(conns[sel]); if (t) t.classList.add("sel"); }
      root.classList.toggle("sel-on", sel >= 0);
    }

    el.scene.addEventListener("click", function (e) {
      if (root.classList.contains("running")) return;
      var tg = e.target.closest ? e.target.closest(".term") : null;
      if (tg) {
        var part = tg.parentNode.getAttribute("data-part");
        var term = tg.getAttribute("data-term");
        var ci = conns.map(function (c) { return c.part + "/" + c.term; }).indexOf(part + "/" + term);
        if (ci >= 0) selectConn(ci);
        return;
      }
      var pg = e.target.closest ? e.target.closest(".pin") : null;
      if (pg) tapPin(pg.getAttribute("data-pin"), pg);
    });

    function tapPin(pid, pg) {
      if (sel < 0) { msg("Pick a component lead first."); return; }
      var c = conns[sel], p = pinmap[pid];
      var owners = conns.filter(function (x) { return x.pin === pid; });
      var isBus = BUS[c.need[0]] && (has(p, "i2c-sda") || has(p, "i2c-scl"));
      var ok = c.need.some(function (n) { return has(p, n); });
      var takenBlock = owners.length > 0 && !isBus;

      if (p.reserved || !ok || takenBlock) {
        misses++;
        pg.classList.remove("bad"); void pg.getBoundingClientRect(); pg.classList.add("bad");
        setTimeout(function () { pg.classList.remove("bad"); }, 460);
        msg(reason(c, p, takenBlock ? owners[0].label : null), "bad");
        return;
      }

      c.pin = pid;
      var w = document.createElementNS(NS, "path");
      w.setAttribute("class", "jw");
      w.setAttribute("stroke", c.color);
      w.setAttribute("d", wirePath(termPos(c), pinPos(pid)));
      w.setAttribute("data-conn", c.i);
      wires.appendChild(w);
      c._wire = w;

      pg.classList.remove("ok"); void pg.getBoundingClientRect(); pg.classList.add("ok");
      paintPin(pid);
      var tE = termEl(c); if (tE) tE.classList.add("done");
      msg("✓ " + c.label + " → " + pid + (isBus && owners.length ? "   (shared bus)" : ""), "good");
      sel = -1; markSel(); refresh();
    }

    function paintPin(pid) {
      var pg = el.scene.querySelector('.pin[data-pin="' + pid + '"]');
      if (!pg) return;
      pg.classList.toggle("used", conns.some(function (c) { return c.pin === pid; }));
    }

    function refresh() {
      [].forEach.call(el.list.children, function (b, k) {
        var c = conns[k];
        b.classList.toggle("done", !!c.pin);
        b.querySelector(".cs").textContent = c.pin || "";
      });
      // reflect terminal done-state (e.g. after unwire)
      conns.forEach(function (c) { var t = termEl(c); if (t) t.classList.toggle("done", !!c.pin); });
      var all = conns.every(function (c) { return c.pin; });
      el.go.disabled = !all;
      if (all) msg("Every lead wired. Upload it. ▶", "good");
    }

    el.go.addEventListener("click", function () {
      if (el.go.disabled) return;
      root.classList.add("running");
      root.classList.remove("sel-on");
      msg("Compiling… uploading…");
      setTimeout(function () {
        root.classList.remove("running");
        root.classList.add("uploaded");
        if (misses === 0) clean++;
        msg("✓ It runs." + (misses === 0 ? "   Clean — first try." : ""), "good");
      }, 1100);
    });

    el.next.addEventListener("click", function () {
      idx++;
      if (idx >= ROUNDS.length) return won();
      render();
    });

    function won() {
      root.classList.add("is-won");
      el.wonH.textContent = clean === 4 ? "Four for four. 🔧" : clean >= 2 ? "Every build wired." : "Every build wired — eventually.";
      el.wonP.textContent = "You fit all four onto the Nano" + (clean < 4 ? " — " + clean + " first-try." : ".") +
        " That planning step is the real start of every project on this shelf.";
      el.again.hidden = false;
      el.cta.hidden = false;
      try { document.dispatchEvent(new CustomEvent("kk:game-won", { detail: { game: "wire-the-build" } })); } catch (e) {}
    }

    var started = false;
    function begin() {
      if (!started) {
        started = true;
        try { document.dispatchEvent(new CustomEvent("kk:game-start", { detail: { game: "wire-the-build" } })); } catch (e) {}
      }
      idx = 0; clean = 0;
      root.classList.remove("is-intro", "is-won", "uploaded", "running");
      render();
    }

    el.start.addEventListener("click", begin);
    el.again.addEventListener("click", begin);

    document.addEventListener("keydown", function (e) {
      if (root.classList.contains("is-intro") || root.classList.contains("is-won")) return;
      var n = parseInt(e.key, 10);
      if (n >= 1 && n <= 9 && el.list.children[n - 1]) el.list.children[n - 1].click();
    });

    root.classList.add("is-intro");
    render();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll(".kkwire[data-kkwire]"), initOne);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.KKWireBuild = { init: boot };
})();
